import * as utils from "./utils";
import * as models from "../models";
import * as cookies from "js-cookie";

/**
 * Gibt den Wert eines Cookies zurück.
 * @param key Der Name des Cookies.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert ist.
 */
export function get<T>(key: string, isBase64: boolean = true): T
{
    var value: string = cookies.get(key);

    if (isBase64)
    {
        value = atob(value);
    }

    return utils.parseValue<T>(value);
}

/**
 * Gibt ein JSON-Objekt aus einem Cookie zurück.
 * @param key Der Name des Cookies.
 * @param isBase64 Angabe, ob der Wert in Base64 codiert ist.
 */
export function getJSON<T>(key: string, isBase64: boolean = true): T
{
    var value: string = cookies.get(key);
    if (value == null)
        return;

    if (isBase64)
    {
        value = atob(value);
    }

    return <T>JSON.parse(value);
}

/**
 * Gibt ein Objekt mit den zuletzt ausgewählten Kalenderdaten zurück.
 */
export function getLastSelection(): { viewMode: string, objectId: number, metadata: models.IMetadata }
{
    var tempCookie: models.ITempCookie = getJSON<models.ITempCookie>("TEMP", true);

    return {
        viewMode: tempCookie.view_mode,
        objectId: (tempCookie.calendar_group_id > 0) ? tempCookie.calendar_group_id : tempCookie.calendar_id,
        metadata: {
            date: tempCookie.date,
            is_group: (tempCookie.calendar_group_id > 0),
            selected_calendar: tempCookie.calendar_id,
            selected_calendars: tempCookie.calendar_ids
        }
    }
}

/**
 * Speichert den übergebenen Wert in einem cookie ab.
 * @param key Der Key für den Eintrag.
 * @param value Der Wert der gespeichert werden soll.
 */
export function set(key: string, value: string, options?: Cookies.CookieAttributes)
{
    cookies.set(key, btoa(value), options);
}

/**
 * Speichert das übergebene JSON-Objekt in einem cookie ab.
 * @param key Der Key für den Eintrag.
 * @param value Der Wert der gespeichert werden soll.
 */
export function setJSON(key: string, value: any, options?: Cookies.CookieAttributes)
{
    cookies.set(key, btoa(JSON.stringify(value)), options);
}

export function remove(key: string)
{
    cookies.remove(key);
}

export function exists(key: string)
{
    return document.cookie.indexOf(`${key}=`) >= 0;
}